export default "__VITE_ASSET__6eda93b6__"